import toArray from "./toArray.js"

function $$(selector, context)
{
  return toArray((context || document).querySelectorAll(selector))
}

export default $$
